import React, { useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { MODEL_COLORS, DATASET_COLORS } from "../../Assets/styles/colors";
import { getClients, getDriveModes, getModels } from "../../APIs";
import { ANALYTICS_DASHBOARD_ACC_CODE, DATE_OPTIONS, DATE_RANGES, DEFAULT_DATE } from "../../Library/constants";
import { StoreContext } from "../../Library/contexts";
import { register, subscribe } from "../../Library/worker";
import WebSocketClient from "../../Library/websocket";
import { Loader } from "../../Pages";
import { getItemFromLocalStorage } from "../../Library/helpers";

const Authenticated = () => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ constants, setConstants ] = useState();
  const [ devStock, setDevStock ] = useState({ walletStock: {} });
  const [ userVehicles, setUserVehicles ] = useState([]);
  const [ vehicleSharingMap, setVehicleSharingMap ] = useState({});
  const [ allVehicleStats, setAllVehicleStats ] = useState({});
  const [ allStates, setAllStates ] = useState([]);
  const [ allGeofences, setAllGeofences ] = useState([]);
  const [ allVehicleRoutes, setAllVehicleRoutes ] = useState([]);
  const [ routesGeofenceMap, setRoutesGeofenceMap ] = useState({});
  const [ routeTriggers, setRouteTriggers ] = useState([]);
  const [ allSubUsers, setAllSubUsers ] = useState([]);

  const [ filters, setFilters ] = useState();
  const [ notifications, setNotifications ] = useState({ unreadCount: 0, notifs: [] });

  const accessCodes = getItemFromLocalStorage("accessCodes");

  const initStore = useCallback(async () => {
    try {
      const modelData = (accessCodes && accessCodes.length && accessCodes.includes(ANALYTICS_DASHBOARD_ACC_CODE)) ? await getModels() : [];
      const modelMap = {};
      modelData.forEach((model, i) => {
        modelMap[model.idx] = { ...model, color: MODEL_COLORS[i % MODEL_COLORS.length] };
      });

      // Setting Default Model and Range Filters
      const models = modelData.map((model) => model.idx);
      let range = DEFAULT_DATE;

      const searchParams = new URLSearchParams(window.location.search);
      const searchRange = Number(searchParams.get("range"));
      if (searchRange) {
        if (searchRange === DATE_OPTIONS.CUSTOM) {
          const fromRange = Number(searchParams.get("from"));
          const toRange = Number(searchParams.get("to"));

          if (fromRange && toRange) {
            DATE_RANGES[DATE_OPTIONS.CUSTOM].from = fromRange;
            DATE_RANGES[DATE_OPTIONS.CUSTOM].to = toRange;

            range = searchRange;
          }
        } else if (DATE_RANGES[searchRange]) {
          range = searchRange;
        }
      }

      const driveModes = await getDriveModes();
      driveModes.push({ idx: 0, label: "All Modes" })
      const driveModeMap = {};
      driveModes.forEach((mode) => {
        driveModeMap[mode.idx] = { ...mode, graph: true, color: DATASET_COLORS.BRANDY };
      });

      let clientData = [];
      let clientMap;
      let client;

      if (!accessCodes || !accessCodes.length) {
        clientData = await getClients();
        clientMap = {};

        if(!clientData || !clientData.length){
          clientData = []
        }
        else{
          clientData.forEach((client) => {
            clientMap[client.idx] = { ...client };
          });
          // Setting first client as default
          client = clientData[0].idx;
        }
      }

      let clientName = window.location.hostname.split(".");
      if (clientName && clientName.length) clientName = clientName[0];

      setConstants({ name: clientName, models: modelData, modelMap: modelMap, driveModeMap: driveModeMap, clients: clientData, clientMap: clientMap, });
      setFilters({ models, range, client });

      setIsLoading(false);
    } catch(e) {
      console.error("Error in Init!", e);
    }
  }, []);

  const onNewNotification = useCallback((notification) => {
    setNotifications((old) => {
      if (!old) return null;
      return { unreadCount: old.unreadCount + 1, notifs: [ notification.data.data, ...old.notifs ] };
    });
  }, []);

  const initServiceWorker = useCallback(async () => {
    try {
      await register();
      await subscribe();

      /* Registering Service Worker Actions */
      const channel = new BroadcastChannel("ajjas-ev-messages");
      channel.addEventListener("message", (event) => {
        onNewNotification(event);
      });

    } catch(error) {
      console.warn("Error in initServiceWorker:", error);
    }
  }, [ onNewNotification ]);

  useEffect(() => {
    initStore();
    initServiceWorker();
    // window.localStorage.setItem("theme", "light");
    // document.body.classList.add("Ev-Light-Theme-Container");
  }, [ initStore, initServiceWorker ]);

  const handleBikes = (bikes) => {
    setUserVehicles(bikes.filter(bike => bike.did));
  }

  const listenForUserVehicles = () => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.ON_BIKES, handleBikes);
  }

  useEffect(() => {
    if (!global.WS) {
      global.WS = new WebSocketClient();
    }

    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, listenForUserVehicles);

    return () => {
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, listenForUserVehicles);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.ON_BIKES, handleBikes);
    }
  }, []);

  if (isLoading) return <Loader />;

  return (
    <StoreContext.Provider value={{ constants, setConstants, filters, setFilters, notifications, setNotifications, devStock, setDevStock, userVehicles, setUserVehicles, vehicleSharingMap, setVehicleSharingMap, allVehicleStats, setAllVehicleStats, allStates, setAllStates, allGeofences, setAllGeofences, allVehicleRoutes, setAllVehicleRoutes, routesGeofenceMap, setRoutesGeofenceMap, routeTriggers, setRouteTriggers, allSubUsers, setAllSubUsers }}>
      <Outlet />
    </StoreContext.Provider>
  )
};

export default Authenticated;
